var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: style */
function SvgPauseVideo(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    id: "pauseVideo_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 20 20",
    xmlSpace: "preserve"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    className: "pauseVideo_svg__st0",
    d: "M16.6 20c-1.3 0-2.4-1-2.4-2.2V2.2C14.2 1 15.3 0 16.6 0S19 1 19 2.2v15.6c0 1.2-1.1 2.2-2.4 2.2zM3.4 20C2.1 20 1 19 1 17.8V2.2C1 1 2.1 0 3.4 0s2.4 1 2.4 2.2v15.6c.1 1.2-1 2.2-2.4 2.2z"
  })));
}
export default SvgPauseVideo;